import { createApis } from 'saga-slice-helpers';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const apis = createApis({

    baseURL: `${baseURL}`,
    timeout: 0
});

export const {
    api,
    sagaApi
} = apis;

export const {
    addAuthorization,
    removeAuthorization,
    addHeader,
    removeHeader
} = api;
